import { useQuery, useMutation } from 'react-query';

import {
    getVms,
    getVmConfigs,
    createVm,
    deployVm,
    purgeVm,
    deleteVm,
    saveVmImage,
    commitVmImage,
} from './queries';

export const useVms = (config) => useQuery('vms', getVms, config);

export const useVmConfigs = (config) =>
    useQuery('vm-configs', getVmConfigs, config);

export const useCreateConfig = (config) => useMutation(createVm, config);

export const useDeployConfig = (config) => useMutation(deployVm, config);

export const usePurgeVm = (config) => useMutation(purgeVm, config);

export const useDeleteVm = (config) => useMutation(deleteVm, config);

export const useSaveVmImage = (config) => useMutation(saveVmImage, config);

export const useCommitVmImage = (config) => useMutation(commitVmImage, config);
